import { get } from 'lodash';

export const UserSettingsEnum = {
  CEPFundsDueBFSTAmountDue: 'CEPFundsDueBFSTAmountDue',
  CEPFundsDueLUNCHAmountDue: 'CEPFundsDueLUNCHAmountDue',
  REACT_TABLES: 'REACT_TABLES',
  POS_SERVING_MENUS: 'POS_SERVING_MENUS',
  POS_SERVING_OPTIONS: 'POS_SERVING_OPTIONS',
  MNU_EDIT_MENU: 'MNU_EDIT_MENU',
  LETTERS_USE_STUDENT_ADDRESS: 'LETTERS_USE_STUDENT_ADDRESS',
};

/**
 * Retrieve key from user settings or use default value
 * @param {Object} settings
 * @param {String} key
 * @param {Any} defaultValue
 */
export const getValueFromSettings = (settings, key, defaultValue) => {
  return get(settings, key, defaultValue);
};

export const MnuEditMenuUserSettingsEnum = {
  ShowMealContributions: 'ShowMealContributions',
  ShowWeeklyMealStandards: 'ShowWeeklyMealStandards',
  ShowDaysOfTheWeek: 'ShowDaysOfTheWeek',
  ShowHoverOver: 'ShowHoverOver',
  ViewBy: 'ViewBy',
  SearchDisableHoverOver: 'SearchDisableHoverOver',
  SearchItemsOnMenu: 'SearchItemsOnMenu',
};

export * from '../state/selectors';



// WEBPACK FOOTER //
// ./src/common/UserSettings/helpers/helper.js